import { Liquid } from "liquidjs";
import _ from "lodash";

const liquidEngine = new Liquid();

export const getLiquidTemplateVariables = (value) => {
    if (_.isUndefined(value)) {
        return [];
    }
    try {
        const ast = liquidEngine.parse(value);
        return liquidEngine.variablesSync(ast).map(e => ({ param_name: e, example: '' }));
    } catch (e) {
        return [];
    }
};